import axios from "axios";
import saasApi from "../../utils/saasApi";
import { mergeMonitoringCameras } from "../adapters/monitoringCameras";
import { authHeaders } from "../../utils/videoToken";

export const getMonitoringEmail = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    if (user.email) return user.email;
    const token = localStorage.getItem("token");
    if (!token) return "";
    const value = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(value + "=".repeat((4 - value.length % 4) % 4))).email || "";
  } catch { return ""; }
};

export const getMonitoringVideoBase = () => {
  try { return localStorage.getItem("absolluty.video_base") || ""; } catch { return ""; }
};

export const getMonitoringCameras = async ({ branchId = "", videoBase = getMonitoringVideoBase() } = {}) => {
  const email = getMonitoringEmail();
  const base = (process.env.REACT_APP_API_BASE || "").replace(/\/v1\/api\/?$/, "").replace(/\/$/, "");
  const [registry, legacy, ai, video] = await Promise.allSettled([
    saasApi.getCameras(), saasApi.getLegacyCameras(),
    email ? axios.get(`${base}/api/sql/ai-streams/${encodeURIComponent(email)}`, { timeout: 10000, headers: authHeaders() }) : Promise.resolve(null),
    videoBase ? axios.get(`${videoBase}/paths`, { timeout: 10000 }) : Promise.resolve(null),
  ]);
  if (registry.status === "rejected" && legacy.status === "rejected" && ai.status === "rejected" && !videoBase) throw registry.reason;
  const streams = ai.status === "fulfilled" && Array.isArray(ai.value?.data?.streams) ? ai.value.data.streams : [];
  const paths = video.status === "fulfilled" && Array.isArray(video.value?.data?.paths) ? video.value.data.paths : [];
  const cameras = mergeMonitoringCameras({
    cameras: registry.status === "fulfilled" ? registry.value.cameras || [] : [],
    legacy: legacy.status === "fulfilled" ? legacy.value : [],
    streams, paths, videoBase, branchId,
  });
  return { cameras, streams, paths };
};

export const updateLegacyMonitoringCamera = (camera, rtspUrl) => axios.put(
  `${(process.env.REACT_APP_API_BASE || "").replace(/\/v1\/api\/?$/, "").replace(/\/$/, "")}/api/cameras/${encodeURIComponent(camera.legacy_id)}`,
  { name: camera.name, rtsp_url: rtspUrl },
  { headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` } }
);
